export default __webpack_public_path__ + "static/media/403.b7be2ad4.svg";